<template>
    <div style="text-align: center">
      <div class="mt-4">
        <button id="pushWcaButton" class="btn btn-success" :disabled="employerPlansPushedToWca" @click="pushWca()">Push Employer and Plans to WCA</button>        
      </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            employerPlansPushedToWca: false
        }
    },
    computed: {
        ...amfx.map("employer", "employerId"),
    },
    methods: {
        async pushWca() {
            if (!(await modalService.confirm("Are you sure you want to push the Employer and Plans to WCA?"))) return;
            this.busy = true;
            try {
                await romeApi.post(`employer/${this.employerId}/pushtowca`);
                await romeApi.post(`employer/${this.employerId}/plan/pushtowca`);
                toastService.success("Employer and Plans Pushed to WCA");
                this.employerPlansPushedToWca = true;
            } 
            catch (err) {
                console.log(err);
                modalService.info(err.message);
            }      
            finally {
                this.busy = false;
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/action-items/types/WcaBuildPlans.vue